/* ==========================================
   Chinese Feng Shui Theme - JavaScript
   WITH Shopify App Integration & AJAX Cart
   ========================================== */

(function() {
  'use strict';
  
  // ✅ 定义Shopify.formatMoney函数（如果不存在）
  window.Shopify = window.Shopify || {};
  if (typeof Shopify.formatMoney !== 'function') {
    Shopify.formatMoney = function(cents, format) {
      const value = (cents / 100).toFixed(2);
      const formattedValue = '$' + value;
      return formattedValue;
    };
  }
  
  // ==========================================
  // MOBILE MENU
  // ==========================================
  function initMobileMenu() {
    const toggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.querySelector('.main-nav');
    
    if (toggle && nav) {
      toggle.addEventListener('click', function() {
        nav.classList.toggle('active');
        this.classList.toggle('active');
      });
      
      // Close menu when clicking outside
      document.addEventListener('click', function(e) {
        if (!toggle.contains(e.target) && !nav.contains(e.target)) {
          nav.classList.remove('active');
          toggle.classList.remove('active');
        }
      });
      
      // Close menu when clicking on a link
      nav.querySelectorAll('.nav-link').forEach(link => {
        link.addEventListener('click', () => {
          nav.classList.remove('active');
          toggle.classList.remove('active');
        });
      });
    }
  }
  
  // ==========================================
  // SMOOTH SCROLL
  // ==========================================
  function initSmoothScroll() {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        e.preventDefault();
        const target = document.querySelector(href);
        
        if (target) {
          const headerHeight = document.querySelector('.site-header')?.offsetHeight || 0;
          const targetPosition = target.offsetTop - headerHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
  
  // ==========================================
  // SCROLL ANIMATIONS
  // ==========================================
  function initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible', 'fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });
  }
  
  // ==========================================
  // AJAX CART - Shopify Integration
  // ==========================================
  
  let cart = { items: [], item_count: 0, total_price: 0 };
  
  // Fetch cart data
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      cart = await response.json();
      updateCartUI();
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }
  
  // Update cart count in header
  function updateCartUI() {
    const cartCount = document.querySelector('.cart-count');
    const cartSubtotal = document.getElementById('cart-subtotal-price');
    
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    
    if (cartSubtotal) {
      // ✅ 使用Shopify.formatMoney格式化金额
      cartSubtotal.textContent = Shopify.formatMoney(cart.total_price);
    }
    
    // ⚠️ 禁用这个函数，让cart-drawer.liquid接管
    // renderCartItems();
  }
  
  // Add to Cart
  function initAddToCart() {
    document.querySelectorAll('.add-to-cart-btn, [name="add"]').forEach(btn => {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        
        const form = this.closest('form[action="/cart/add"]');
        const variantId = this.dataset.variantId || (form && form.querySelector('[name="id"]')?.value);
        const quantity = parseInt(this.dataset.quantity || (form && form.querySelector('[name="quantity"]')?.value) || 1);
        
        if (!variantId) {
          showNotification('Please select a variant', 'error');
          return;
        }
        
        // Disable button
        const originalText = this.textContent;
        this.disabled = true;
        this.textContent = 'Adding...';
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              sections: 'cart-drawer'
            })
          });
          
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          
          await fetchCart();
          // ✅ 调用window.openCartDrawer（由cart-drawer.liquid提供）
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
          showNotification('Product added to cart!');
        } catch (error) {
          console.error('Error adding to cart:', error);
          showNotification('Error adding to cart', 'error');
        } finally {
          this.disabled = false;
          this.textContent = originalText;
        }
      });
    });
  }
  
  // Update cart item quantity
  async function updateCartItem(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      
      cart = await response.json();
      updateCartUI();
      showNotification(quantity === 0 ? 'Item removed from cart' : 'Cart updated');
      
      // ✅ 触发cart-drawer.liquid重新加载
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      showNotification('Error updating cart', 'error');
    }
  }
  
  // Cart Drawer Controls
  function initCartDrawer() {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartIconWrapper = document.querySelector('.cart-icon-wrapper');
    const closeBtn = document.querySelector('.cart-drawer-close');
    const overlay = document.querySelector('.cart-drawer-overlay');
    
    console.log('🔧 initCartDrawer called');
    console.log('🔧 cartIconWrapper:', cartIconWrapper);
    console.log('🔧 window.openCartDrawer:', typeof window.openCartDrawer);
    
    // ✅ 绑定购物车图标点击事件 - 调用window.openCartDrawer（由cart-drawer.liquid定义）
    if (cartIconWrapper) {
      cartIconWrapper.addEventListener('click', function(e) {
        console.log('🖱️ Cart icon clicked!');
        e.preventDefault();
        // ✅ 调用window.openCartDrawer（必须由cart-drawer.liquid提供）
        if (typeof window.openCartDrawer === 'function') {
          console.log('📞 Calling window.openCartDrawer...');
          window.openCartDrawer();
        } else {
          console.error('❌ openCartDrawer function not found - cart-drawer.liquid not loaded?');
        }
      });
      console.log('✅ Cart icon click event bound');
    } else {
      console.error('❌ Cart icon wrapper not found!');
    }
  }
  
  // ⚠️ 完全移除theme.js中的window.openCartDrawer定义
  // ⚠️ 让cart-drawer.liquid完全接管这个函数
  // ⚠️ theme.js只负责绑定点击事件，不定义函数本身
  
  function closeCartDrawer() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  // ==========================================
  // NOTIFICATION SYSTEM
  // ==========================================
  function showNotification(message, type = 'success') {
    // Remove existing notification
    const existingNotification = document.querySelector('.notification');
    if (existingNotification) {
      existingNotification.remove();
    }
    
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 100px;
      right: 20px;
      background: ${type === 'success' ? '#d4af37' : '#e74c3c'};
      color: #1a0f0f;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      z-index: 10000;
      animation: slideInRight 0.3s ease;
      font-weight: 600;
      max-width: 300px;
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
  
  // ==========================================
  // NEWSLETTER FORM
  // ==========================================
  function initNewsletterForm() {
    const forms = document.querySelectorAll('.newsletter-form');
    
    forms.forEach(form => {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const email = this.querySelector('input[type="email"]').value;
        const submitBtn = this.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;
        
        submitBtn.disabled = true;
        submitBtn.textContent = 'Subscribing...';
        
        try {
          const response = await fetch('/contact', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `form_type=customer&contact[tags]=newsletter&contact[email]=${encodeURIComponent(email)}`
          });
          
          if (response.ok) {
            showNotification('Successfully subscribed to newsletter!');
            this.reset();
          } else {
            throw new Error('Subscription failed');
          }
        } catch (error) {
          console.error('Newsletter error:', error);
          showNotification('Error subscribing. Please try again.', 'error');
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
    });
  }
  
  // ==========================================
  // PRODUCT QUICK VIEW (Shopify App Support)
  // ==========================================
  function initQuickView() {
    document.querySelectorAll('[data-quick-view]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const productHandle = this.dataset.quickView;
        // Trigger Shopify app event for quick view
        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
          console.log('Quick view:', productHandle);
        }
      });
    });
  }
  
  // ==========================================
  // SHOPIFY THEME EDITOR SUPPORT
  // ==========================================
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      console.log('Section loaded:', event.detail.sectionId);
      // Reinitialize section-specific JS
      initMobileMenu();
      initAddToCart();
      initScrollAnimations();
    });
    
    document.addEventListener('shopify:section:unload', function(event) {
      console.log('Section unloaded:', event.detail.sectionId);
    });
    
    document.addEventListener('shopify:section:select', function(event) {
      console.log('Section selected:', event.detail.sectionId);
    });
  }
  
  // ==========================================
  // INITIALIZE ALL
  // ==========================================
  function init() {
    initMobileMenu();
    initSmoothScroll();
    initScrollAnimations();
    fetchCart();
    initAddToCart();
    initCartDrawer();
    initNewsletterForm();
    initQuickView();
    
    // Log for debugging
    console.log('Chinese Feng Shui Theme initialized');
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Add animation styles dynamically
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
  
  // Expose cart functions globally for theme customization
  window.theme = window.theme || {};
  window.theme.cart = {
    fetch: fetchCart,
    update: updateCartItem,
    // ✅ open函数由cart-drawer.liquid提供
    open: function() {
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      } else {
        console.error('openCartDrawer not available');
      }
    },
    close: closeCartDrawer
  };
  
})();